module.exports = [
  'en-CA',
  'en-GB',
  'en-IE',
  'en-US',
  'es-ES',
  'es-MX',
  'fr-FR',
  'hi-IN',
  'zh-CN',
  'es-US',
  'es-CL',
  'pt-BR',
  'fr-CA',
]
